module.exports = __webpack_public_path__ + "img/solutionBanner_1.ef310159.png";